import React from "react";
import TlkTable from "../../tlelrik/table/tlkTable";
import services from "../../../services";
import queryString from "query-string";
var moment = require("moment");

// - INICIAL
// Produto
// Tipo de conta
// Menção especial *
// Data de criação
// Ano Conta
// Ano Vindima *
// Registo *
// Cor *
// Saldo Granel *
// Saldo Apto *
// Saldo Engarrafado *
// Saldo
// Saldo Cativo


// - COLUNAS SHAREPOINT
// Local de Armazenagem
// Instalação Vinica
// Produto
// Tipo de Conta
// Número de Registo
// Menção Complementar
// Menção Obrigatória
// Cor
// Ano	Granel
// Saldo Cativo
// Saldo Indisp a Granel
// Saldo Indisp Engarrafado
// Produto acabado
// Menção Facultativa

const columnKeyMap = {
    localArmazenagem: "Local de Armazenagem",
    instalacaoVinica: "Instalação Vínica",
    produto: "Produto",
    tipoConta: "Tipo de Conta",
    nivelConta: "Nível de Conta",
    estado: "Estado",
    cor: "Cor",
    anoProduto: "Ano",
    numeroRegisto: "Número de Registo",
    mencaoComplementar: "Menção Complementar",
    mencoes: "Menção Comp Desc",
    mencaoObrigatoria: "Menção Qualitativa",
    mencaoFacultativa: "Menção Facultativa",
    // saldoGranel: "Granel",
    // saldoIndispGranel: "Saldo Indisp a Granel",
    // saldoIndispEngarrafado: "Saldo Indisp Engarrafado",
    // saldoProdutoAcabado: "Produto acabado",
    saldo: "Saldo",
    
    dataUltimoMovimento: "Data Último Movimento",
    
    
};

const groupfield = [{ field: "Nível de Conta" }, { field: "Estado" }];

const dateFormat = "DD-MM-YYYY HH:mm:ss";

const actionbuttons = { CommonRedirection: "Account listing screen" };

class AccountTab extends React.Component {
    constructor() {
        super();

        this.state = {
            loaded: false,
            data: [],
            columnList: [],
            totalCount: 0,
            filters: {
                Filters: { entityId: null },
                FiltersIn: null,
                FiltersLike: null,
                SortBy: "",
                IsSortTypeDESC: true,
                IsPagination: false,
                Page: 2,
                PageSize: 2,
            },
        };
    }

    componentDidMount() {
        (async () => {
            const queryParams = queryString.parse(this.props.location.search);
            let query = {};
            query["entityId"] = queryParams["entityId"];
            query["instalacaoVinicaId"] = queryParams["IDInstalacaoVinica"];
            const filters = {
                ...this.state.filters,
                Filters: query,
            };
            // console.log("accont tab worked...6767 ", queryParams);

            const response = await services.apiCall.requestApi(
                "ContaCorrente/GetContasCorrentes",
                filters,
                "post"
            );
            // const columnList = Object.keys(columnKeyMap).map((key) => ({
            //     field: columnKeyMap[key],
            //     columnMenuType: "checkbox",
            // }));
            var columnList = [];

            Object.keys(columnKeyMap).forEach(e => {
                if(e == "numeroRegisto" || e == "anoProduto" || e == "mencaoComplementar"){
                    columnList.push({field: columnKeyMap[e], columnMenuType: "number"});
                }
                else if (e == "saldo"){
                    columnList.push({field: columnKeyMap[e], columnMenuType: "number", footerCell: e});
                }
                else{
                    columnList.push({field: columnKeyMap[e], columnMenuType: "checkbox"});
                }
            });
            // console.log("AccountTab -> ColumnList", columnList);
            if (response && response.length > 0) {
                const data = response.map((entity) => ({
                    ...entity,
                    ...Object.keys(columnKeyMap).map((key) => {
                        entity[columnKeyMap[key]] = entity[key];
                        if (key === "dataCriado")
                            entity[columnKeyMap[key]] = entity["dataCriado"]
                                ? moment(entity["dataCriado"]).format(
                                      dateFormat
                                  )
                                : "nd";
                        else if (key === "distrito") {
                            entity[columnKeyMap[key]] =
                            entity.idNivelConta == 4 ? services.money.format(entity.saldoDisponivel) ||
                                0 : 0;
                        } 
                        if (key === "saldoApto") {
                            entity[columnKeyMap[key]] =
                            entity.idNivelConta == 3 ? services.money.format(entity.saldoDisponivel) ||
                                0 : 0;
                        }
                        else if (
                            key === "saldoGranel" ||
                            key === "saldoEngarrafado" ||
                            key === "comercializado"
                        ) {
                            entity[columnKeyMap[key]] = services.money.format(entity[key]) || "0";
                        }
                        if (key === "saldo") {
                            entity[columnKeyMap[key]] = services.money.format(entity.saldo) || "0";
                        }
                        if (key === "saldoCativo") {
                            entity[columnKeyMap[key]] =
                                services.money.format(entity[key]) || 0;
                        }
                        else if (key === "dataUltimoMovimento"){
                            entity[columnKeyMap[key]] = moment(
                                entity.dataUltimoMovimento
                            ).format(dateFormat)
                        }
                    }),
                    selected: false,
                }));
                console.log("AccountTab -> Resposta: ", data);
                console.log("AccountTab -> ColumnList: ", columnList);
                this.setState(() => ({
                    data,
                    columnList,
                    totalCount: window.localStorage.getItem("table_total"),
                    loaded: true,
                }));
            } else {
                this.setState(() => ({
                    data: response,
                    totalCount: 0,
                    columnList,
                    loaded: false,
                }));
            }
        })();
    }

    selectionChange(selection) {
        const data = [...this.state.data].map((item) => {
            if (selection.dataItem.codContaCorrente === item.codContaCorrente) {
                // TODO: Ask @Dart for the unique key to use here
                return { ...item, selected: true };
            } else {
                return { ...item, selected: false };
            }
        });
        this.setState({ data }, async () => {
            let query = queryString.parse(this.props.location.search);
            // console.log("query is ", query);
            let queryParams = queryString.stringify({
                ...queryString.parse(this.props.location.search),
                accountId: 0,
            });
            this.props.history.push(`/conta_corrente/movements?${queryParams}`);
        });
    }

    ActionPerform = async (action, row) => {
        // TODO: Rohit — Export data from grid
        if (action === "addMovement") {
            console.log("row");
            console.log(row);
            const queryParams = queryString.stringify({
                ...queryString.parse(this.props.location.search),
                accountId: row.idContaCorrente,
                ano: row.anoProduto,
                idCor: row.idCor,
                tdc: row.descricao,
                pr: row.produto,
                ncc: row.codContaCorrente,
                sa: row.saldo,
                iva: row.instalacaoVinica,
                idEst: row.idEstatuto,
                idTC: row.idTipoConta,
                sldG: row.saldoGranel,
                sldA: row.saldoApto,
                sldE: row.saldoEngarrafado,
                tpc: row.tipoConta,
                estado: row.estado,
                idp: row.idProduto
            });
            console.log("QPARAMS BEFORE");
            console.log(queryParams);
            console.log("ROW BEFORE");
            console.log("OLAAAA");
            console.log(row)
            this.props.history.push(
                `/conta_operações/movements?${queryParams}`
            );
        } else if (action === "movementDetails") {
            // const data = [...this.state.data].map((item) => {
            //   if (row.codContaCorrente === item.codContaCorrente) { // TODO: Ask @Dart for the unique key to use here
            //     return { ...item, selected: true };
            //   } else {
            //     return { ...item, selected: false };
            //   }
            // });
            // this.setState({ data }, async () => {
            // console.log("......pppiiii 999000", row, action);
            const queryParams = queryString.stringify({
                ...queryString.parse(this.props.location.search),
                accountId: row.idContaCorrente,
                tdc: row.tipoConta,
                pr: row.produto,
                ncc: row.codContaCorrente,
                sa: row.saldo,
                sldG: row.saldoGranel,
                sldA: row.saldoApto,
                sldE: row.saldoEngarrafado,
                estado: row.estado,
                nrReg: row.numeroRegisto
            });
            console.log("QPARAMS BEFORE");
            console.log(queryParams);
            console.log("ROW BEFORE");
            console.log(row);
            //this.props.history.push(`/conta_corrente/movements/movementlist?${queryParams}`);
            this.props.history.push(`/conta_corrente/movements?${queryParams}`);
            // });
        }
    };

    render() {
        let message = `${this.state.totalCount} Contas Correntes ativas para a entidade selecionada`;
        return (
            <>
                {this.state.loaded && (
                    <>
                        {/* <span>{this.state.totalCount} Contas Correntes ativas da Entidade na entidade selecionada</span> */}
                        <TlkTable
                            date={new Date()}
                            list={this.state.data}
                            modulename={"Conta Corrente"}
                            // notAction={false}
                            // notGroup={true}
                            actionbuttons={actionbuttons}
                            columnlist={this.state.columnList}
                            groupfield={groupfield}
                            ActionPerform={(action, id) =>
                                this.ActionPerform(action, id)
                            }
                            // selection={ true }
                            // selectionChange={ (e) => this.selectionChange(e) }
                            actionColWidth={69}
                            toolbarHTML={message}
                        />
                    </>
                )}
            </>
        );
    }
}

export default AccountTab;
